// @flow
import * as React from "react";
import styled from "styled-components";

type Props = {
  $offset?: number,
};

const FullHeightContainer: React.ComponentType<Props> = styled.div`
  height: 100%;

  ${(props: Props) => {
    if (props.$offset) {
      return `
        height: calc(100% - ${props.$offset}px);
      `;
    }
  }}
`;

export default FullHeightContainer;
